export default {
    breadcrumb: {
        settlements: 'Envios >',
        settlementId: 'Envio {id}',
    },
    title: 'Envio',
    createdAt: 'Data do envio',
    totalAmount: 'Valor total',
    sponsor: 'Operadora',
    loadingDataLabel: 'Carregando contas',
    emptyDataLabel: 'Não há contas neste envio',
    resultLabel: 'Documentos anexos | {count} Documento anexado | {count} Documentos anexados',
    NoResults: '{result} contas',
    attachedDocuments: 'Nenhuma conta encontrada',
    grid: {
        authorizationId: 'ID da conta',
        createdAt: 'Data de criação',
        beneficiary: 'Beneficiário',
        memberCode: 'Carteirinha',
        coverage: "Proteção", 
        branch: 'Empresa',
        amount: 'Valor à pagar',
    },
    filters: {
        searchCode: 'Procurar por ID de conta',
    },
    reasonRejection: 'Motivo de recusa',
}